import { Locale } from '@ardoq/locale';
import {
  BubbleChartDataPointModel,
  BubbleChartDomains,
  BubbleChartScalers,
  BubbleChartViewLegendProps,
  RadiusFieldLegendData,
} from '../types';
import { APIOrganizationUser, DiffMode } from '@ardoq/api-types';
import {
  getActiveConditionalFormattingForLegend,
  getComponentTypesForLegend,
} from '@ardoq/view-legend';
import { type I18nLocale } from '@ardoq/i18n';
import { getBubbleLegendRow } from './getBubbleLegendRow';

type GetBubbleChartViewLegendPropsArgs = {
  data: BubbleChartDataPointModel[];
  radiusFieldData: RadiusFieldLegendData;
  domain: BubbleChartDomains;
  scalers: BubbleChartScalers;
  activeDiffMode: DiffMode | null;
  isScopeDiffMode: boolean;
  locale: Locale;
  i18nLocale: I18nLocale;
  showBubblesWithZeroValue?: boolean;
  isViewpointMode: boolean;
  users?: APIOrganizationUser[];
};
export const getBubbleChartViewLegendContents = ({
  data,
  radiusFieldData,
  domain,
  scalers,
  activeDiffMode,
  isScopeDiffMode,
  locale,
  i18nLocale,
  showBubblesWithZeroValue = true,
  isViewpointMode,
  users,
}: GetBubbleChartViewLegendPropsArgs): Omit<
  BubbleChartViewLegendProps,
  'isLegendActive'
> => {
  const componentTypes = getComponentTypesForLegend(data.map(data => data.cid));
  const activeConditionalFormatting = getActiveConditionalFormattingForLegend(
    i18nLocale,
    undefined,
    isViewpointMode,
    users
  );
  const additionalRows = getBubbleLegendRow(
    radiusFieldData,
    data,
    domain.radius,
    scalers.radius,
    scalers.unscaleRadius,
    showBubblesWithZeroValue,
    locale
  );
  return {
    componentTypes,
    activeConditionalFormatting,
    additionalRows,
    activeDiffMode: isScopeDiffMode ? activeDiffMode : null,
  };
};
